<template>
    <div class="container mx-auto px-4 ">

        <div class="flex flex-col justify-center items-center min-h-full text-white">
            <p class="title text-center">Page not found!</p>
            <p class="text-2xl font-bold uppercase">Try another link.</p>


        </div>

    </div>
</template>